export default __webpack_public_path__ + "static/media/excel_icon.622e7ecd.svg";